import { FC } from 'react'

import Sumologic from '@/assets/logos/sumologic.svg?react'
import ServiceIntegrationCard from '@/components/service-integration-card'
import { Logging } from '@/out/logging'
import { LoggingProps } from '@/pages/settings/logging'

import SumologicDetails from './details'
import SumologicForm from './form'

type Props = LoggingProps<'sumologic'> & {
  configuration: Logging['sumologic']
}

const SumologicIntegration: FC<Props> = ({
  configuration,
  onSetup,
  setupTimer,
  onTest,
  testTimer,
  onRemove,
  removeTimer,
}) => {
  return (
    <ServiceIntegrationCard
      title="Sumo Logic"
      description="Monitor application performance and logs"
      icon={<Sumologic className="w-8 h-8" />}
      iconColor="text-[#00D4AA] dark:text-white"
      isConnected={!!configuration}
      setupContent={
        <SumologicForm
          setupTimer={setupTimer}
          testTimer={testTimer}
          onSetup={config => onSetup('sumologic', config)}
          onTest={config => onTest('sumologic', config)}
        />
      }
      manageContent={
        configuration && (
          <SumologicDetails configuration={configuration} timer={removeTimer} onRemove={() => onRemove('sumologic')} />
        )
      }
    />
  )
}

export default SumologicIntegration
